import { render } from "./TransPopupContainer.vue?vue&type=template&id=6a425819&lang=true"
import script from "./TransPopupContainer.vue?vue&type=script&lang=js"
export * from "./TransPopupContainer.vue?vue&type=script&lang=js"

import "./TransPopupContainer.vue?vue&type=style&index=0&id=6a425819&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__